export default "__VITE_ASSET__Onr7X_gb__"